import { EscalationTarget } from "./enums";

// True while the loan's latest escalation is still Pending against Capital
// Markets (the "Capital Market Review" loan status) and the loan hasn't been
// submitted. Mirrors the status derivation in ListView.tsx / LoansPagev2.tsx.
export const isUnderCapitalMarketReview = (
  loanDetails: { escalations?: any[]; tcLoanId?: string } | undefined | null,
): boolean => {
  if (loanDetails?.tcLoanId) return false;
  const escalations = loanDetails?.escalations;
  if (!Array.isArray(escalations) || !escalations.length) return false;
  const last = escalations[escalations.length - 1];
  return (
    last?.underwritingStatus === "Pending" &&
    Array.isArray(last?.escalatedTo) &&
    last.escalatedTo.includes(EscalationTarget.capitalMarket)
  );
};

// Pricing output cards/tables hidden from everyone except Capital Markets
// (who must see them to price) while the loan is under their review.
export const PRICING_OUTPUT_LABELS = ["pricing", "finalPrice", "finalPriceTable", "interestRate"];

// True while the loan's latest escalation is Pending against the underwriter
// and/or credit committee (the "CC/UW Review" loan status) and the loan
// hasn't been submitted.
export const isUnderCcUwReview = (
  loanDetails: { escalations?: any[]; tcLoanId?: string } | undefined | null,
): boolean => {
  if (loanDetails?.tcLoanId) return false;
  const escalations = loanDetails?.escalations;
  if (!Array.isArray(escalations) || !escalations.length) return false;
  const last = escalations[escalations.length - 1];
  const targets: string[] = Array.isArray(last?.escalatedTo) ? last.escalatedTo : [];
  return (
    last?.underwritingStatus === "Pending" &&
    (targets.includes(EscalationTarget.underwriter) ||
      targets.includes(EscalationTarget.creditCommittee))
  );
};
